import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { EnvService } from '@services/env.service';
import { UserService } from '@services/user.service';
import { Toast, ToastServiceManager } from '@services/toast-service-manager.service';
import { UserInformation } from '@models/user-information.model';

@Injectable({
  providedIn: 'root',
})
export abstract class PremiseHazardRestBase {
  constructor(
    protected httpClient: HttpClient,
    protected envService: EnvService,
    protected toastServiceManager: ToastServiceManager,
    protected userService: UserService,
  ) {
    this.userService.UserInformation.subscribe((userInfo) => {
      if (!userInfo || !userInfo.isSuperAdmin) {
        this.customerRoute = '';
      } else if (userInfo.isSuperAdmin && userInfo.selectedCustomerId) {
        this.customerRoute = `/${userInfo.selectedCustomerId}/${userInfo.selectedCustomerId}`;
      }
      this.userInfo = userInfo!;
    });
    this.environment = this.envService.env1;
    this.domainExtension = this.envService.domainExtension;
    this.phzBaseUrl = `https://coregis${this.environment}commandcentral.${this.domainExtension}`;
    this.geoVerificationUrl = `https://coregis${this.environment}commandcentral.${this.domainExtension}/geoverification/v1`; //`http://localhost:5004/geoverification/v1`;
  }
  public geoVerificationUrl: string;

  protected readonly MsiProduct: string = 'PHZ';
  protected environment: string;
  protected domainExtension: string;
  protected userInfo!: UserInformation;

  protected phzBaseUrl: string;
  // protected phzBaseUrl = `http://localhost:5000`;

  protected queryUrl = '/premisehazards/v2';
  protected adminUrl = '/admin/premisehazards/v2';
  protected reportUrl = '/report/premisehazards/v2';
  protected commandUrl = '/command/premisehazards/v2';
  protected customerRoute: string = '';

  protected addCustomerRoute(): string {
    return this.customerRoute;
  }

  protected createHttpParams(requestOptions: any): HttpParams {
    let params = new HttpParams();

    for (let key in requestOptions) {
      if (requestOptions[key] !== undefined && requestOptions[key] !== null) {
        params = params.set(key, requestOptions[key]);
      }
    }
    return params;
  }

  protected showRestError(message: string, messageProperty: Toast | undefined): void {
    if (!messageProperty) {
      this.toastServiceManager.error(message, undefined, {
        closeButton: true,
        onRemove: () => (messageProperty = undefined),
      });
    }
  }

  private serviceUnavailableToast?: Toast;
  private badRequestErrorToast?: Toast;
  private unauthorizedErrorToast?: Toast;
  private forbiddenErrorToast?: Toast;
  private notFountErrorToast?: Toast;
  private conflictErrorToast?: Toast;
  private preconditionFailedToast?: Toast;
  private tooManyRequestsErrorToast?: Toast;
  private restErrorToast?: Toast;
  private unknownErrorToast?: Toast;

  protected handleHttpError(err: HttpErrorResponse) {
    if (err.status === 0) {
      this.showRestError('The service is not available. Please try again later.', this.serviceUnavailableToast);
    } else if (err.status === 400) {
      // Bad Request
      const detail = err.error?.detail ?? err.error?.Message ?? err.message;
      this.showRestError('There was an error with your request: ' + detail, this.badRequestErrorToast);
    } else if (err.status === 401) {
      // Unauthorized
      this.showRestError(
        'You are not authorized to perform this action. You may need to log in again.',
        this.unauthorizedErrorToast,
      );
    } else if (err.status === 403) {
      // Forbidden
      this.showRestError('You are not authorized to perform this action.', this.forbiddenErrorToast);
    } else if (err.status === 404) {
      this.showRestError(
        'The item you are trying to access does not exist, it may have been deleted.',
        this.notFountErrorToast,
      );
    } else if (err.status === 409) {
      // Conflict
      this.showRestError(
        'The change you made conflicts with a change made by another user. Please refresh the page and try again.',
        this.conflictErrorToast,
      );
    } else if (err.status === 412) {
      // Precondition Failed
      this.showRestError(
        'The item being updated has been modified since you retrieved it. Please refresh the page and try again.',
        this.preconditionFailedToast,
      );
    } else if (err.status === 429 || err.status === 449) {
      // Too Many Requests
      this.showRestError('The service is busy, please wait a moment and try again.', this.tooManyRequestsErrorToast);
    } else if (err.status === 500 || err.status === 502 || err.status === 503) {
      // Internal Server Errors
      this.showRestError(
        'An error occurred while processing your request. Please try again later.',
        this.restErrorToast,
      );
    } else {
      this.showRestError(
        `An error ocurred processing your request: ${err.status} ${err.statusText}`,
        this.unknownErrorToast,
      );
    }
  }
}
